import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ErrorComponent} from './shared-module/components/error/error.component';
import {OktaAuthGuard} from '@okta/okta-angular';
import {UnauthorizedAccessComponent} from './shared-module/components/unauthorized-access/unauthorized-access.component';
import {SearchComponent} from './search/search.component';
import {PageAccessInfoGuardService} from './shared-module/guards/page-access-guard.service';
import { PageAccessAdminGuardService } from './shared-module/guards/page-access-admin-guard.service';

const routes: Routes = [
  {
    path: '',
    component: SearchComponent,
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      errorCode: 'Error',
      message: 'Sorry, your access for this resource is denied for some reason.',
      title: 'Access denied'
    }
  },
  {
    path: 'access_denied',
    component: UnauthorizedAccessComponent,
  },
  {
    path: 'product/:smartNumber',
    canActivate: [OktaAuthGuard, PageAccessInfoGuardService],
    loadChildren: () => import('./product-view-module/product-view.module')
      .then(m => m.ProductViewModule)
  },
  {
    path: 'product/:smartNumber/edit',
    canActivate: [OktaAuthGuard, PageAccessInfoGuardService],
    loadChildren: () => import('./product-view-module/product-view.module')
      .then(m => m.ProductViewModule)
  },
  {
    path: 'report',
    canActivate: [OktaAuthGuard, PageAccessInfoGuardService],
    loadChildren: () => import('./report-module/report.module')
      .then(m => m.ReportModule)
  },
  {
    path: 'administration',
    canActivate: [OktaAuthGuard, PageAccessInfoGuardService, PageAccessAdminGuardService],
    loadChildren: () => import('./administration-module/administration.module')
      .then(m => m.AdministrationModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
